import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { TrlFormDropdown, TrlTextField } from '»components/atoms/Inputs';
import { TrlDatePicker } from '»components/atoms/Inputs/TrlDatePicker';
import {
  getAvailableFundsOrdTypes,
  operations,
  RESCUE_ORD_TYPES,
} from '»components/templates/TrlInsertOrder/TrlInsertOrderModal/TrlInsertOrderModal.helper.selectors';
import { useDotsNotCommas } from '»utils/customHooks';

const fundsOperations = operations.filter(
  (operation) => operation.market === 'funds',
);

export const TrlFundsFields = ({ subscriptionType }) => {
  const { values, setFieldValue } = useFormikContext();
  const { replaceCommasWithDots } = useDotsNotCommas();

  const {
    selectOrderType,
    selectOperation,
    inputQuantity,
    selectExpirationDate,
  } = values;

  const availableFundsOrdTypes = useMemo(() => {
    if (selectOperation === 'E') return RESCUE_ORD_TYPES;

    return getAvailableFundsOrdTypes(subscriptionType);
  }, [subscriptionType, selectOperation]);

  const currentOrderTypeLabel = availableFundsOrdTypes.find(
    (ordType) => ordType.value === selectOrderType,
  )?.label;

  return (
    <>
      <TrlFormDropdown
        name="selectOrderType"
        label={<FormattedMessage id="TRLT_UI-ORDER_TYPE" />}
        value={selectOrderType}
        options={availableFundsOrdTypes}
        onChangeValue={(event) => {
          const selectedOrder = event.target.value;
          if (selectedOrder === 1) setFieldValue('selectOperation', 'D');
        }}
      />
      <TrlFormDropdown
        name="selectOperation"
        label={<FormattedMessage id="TRLT_UI-OPERATION" />}
        value={selectOperation}
        options={fundsOperations}
        onChangeValue={(event) => {
          const operationType = event.target.value;
          const availableOrdTypes =
            operationType === 'E'
              ? RESCUE_ORD_TYPES
              : getAvailableFundsOrdTypes(subscriptionType);

          setFieldValue('selectOrderType', availableOrdTypes[0]?.value);
        }}
      />
      <TrlTextField
        name="inputQuantity"
        type="number"
        label={
          currentOrderTypeLabel && (
            <FormattedMessage id={currentOrderTypeLabel} />
          )
        }
        value={inputQuantity}
        additionalFunc={(event) => {
          replaceCommasWithDots({
            inputName: 'inputQuantity',
            inputValue: event.target.value,
          });
        }}
        hasPadding
      />
      <TrlDatePicker
        name="selectExpirationDate"
        label={<FormattedMessage id="TRLT_UI-EXPIRATION_DATE" />}
        value={selectExpirationDate}
        isDisabled
        disableWeekends
        dateFormatType="dateTime"
      />
    </>
  );
};

TrlFundsFields.propTypes = {
  subscriptionType: PropTypes.string.isRequired,
};
